import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MailerBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/mailer/feature","featureId":"common-mailer"},
      bundledItemModels: ["MailTemplateItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users', 'common-mail'],
      abilityActions: false,
      plugins: [{
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MailerFrontendAdminFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MailerBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {};
  }
}